export const statusStyleArray = [
  {
    status: "due",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "ongoing",
    color: "#096dd9",
    backgroundColor: "#e6f7ff",
  },
  {
    status: "INITIATED",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "completed",
    color: "#389e0d",
    backgroundColor: "#f6ffed",
  },
  {
    status: "CREATED",
    backgroundColor: "#d46b08",
    color: "#fff7e6",
  },
  {
    status: "PAID",
    color: "#fff",
    backgroundColor: "rgb(56, 158, 13)",
  },
  {
    status: "delivered",
    color: "#389e0d",
    backgroundColor: "#f6ffed",
  },
  {
    status: "due",
    backgroundColor: "#c41d7f",
    color: "#fff0f6",
  },
];
